export default __webpack_public_path__ + "static/media/go-mini.570b066a.jpg";